import React, { useState, useContext } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import { APIURLContext } from '../../contexts/APIURLContext';
import axios from 'axios';
import './RegistrationForm.css'; 

export default function RegistrationForm() {
    const [inputs, setInputs] = useState({});
    const apiURL = useContext(APIURLContext);
    const navigate = useNavigate();

    // Function that posts form data to the API
    async function registerUser(credentials) {
        try {
            let res = await axios.post(apiURL + '/users/register', credentials);
            console.log(res.data);
            return res.data;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    // Handler function for form field changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInputs(prevValues => ({ ...prevValues, [name]: value }));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Create an object that contains the registration data entered by the user
        localStorage.removeItem('accessToken');

        let registrationData = {
            name: {
                first: inputs.first,
                last: inputs.last
            },
            email: inputs.email,
            username: inputs.username,
            password: inputs.password
        };

        const registrationResponse = await registerUser(registrationData);
        if (registrationResponse === null) {
            alert("Registration failed. Please check details.");
        } else {
            console.log("Registration successful!");
            navigate('/login'); // Redirect to login page after successful registration
        }
    }

    return (
        <div className="registration-form-container">
            <label>Register</label>
            <form method="post" onSubmit={handleSubmit}>
                <input 
                type="text"
                placeholder="First Name"
                value={inputs.first || ""} 
                name="first" 
                onChange={handleChange}
                             />
            <input 
                type="text"
                placeholder="Last Name"
                value={inputs.last || ""} 
                name="last" 
                onChange={handleChange}
            />
               
               <input 
                    type="email"
                    placeholder="Email"
                    value={inputs.email || ""} 
                    name="email" 
                    onChange={handleChange}
                />

                <input 
                    type="text"
                    placeholder="Username"
                    value={inputs.username || ""} 
                    name="username" 
                    onChange={handleChange}
                />
                <input 
                    type="password" 
                    placeholder="Password"
                    value={inputs.password || ""} 
                    name="password" 
                    onChange={handleChange}
                />
                <div className="submit-container">
                    <input type="submit" value="Register" />
                </div>
            </form>
        </div>
    );
}
